{
  "WALLBOARD": {
    "LOADING": "Завантаження черг телефону...",
    "NO_QUEUES": "Телефонні черги не знайдено.",
    "AGENTS": "Агенти",
    "NO_AGENTS": "У цій черзі немає агентів онлайн.",
    "NO_AGENTS_ONLINE": "Немає агентів онлайн.",
    "WAITING_CALLERS": "Абоненти в очікуванні",
    "NO_CALLERS": "Немає абонентів в очікуванні.",
    "UNKNOWN_CALLER": "Невідомий абонент",
    "POSITION": "Позиція",
    "STATUS": "Статус",
    "TIME": "Час",
    "AGENT": "Агент",
    "EXTENSION": "Внутрішній номер",
    "AVAILABLE": "Доступний",
    "READY": "Готові агенти",
    "ON_CALL": "Агенти на виклику",
    "QUEUE_CALL": "Виклик з черги",
    "OTHER_CALL": "Інший виклик",
    "PAUSED": "Агенти на перерві",
    "WAITING": "Виклики в очікуванні",
    "MISSED_CALLS": "Пропущені виклики",
    "HANDLED_CALLS": "Оброблені вхідні виклики",
    "OUTBOUND_CALLS": "Оброблені вихідні виклики",
    "AVAILABILITY": "Доступність",
    "AVAILABILITY_TOOLTIP": "Відсоток вхідних викликів, на які відповіли агенти (виклики, які були прийняті)",
    "TOTAL": "всього",
    "AGENTS_COUNT": "({onCall} на виклику / {total} всього)",
    "NO_AVAILABLE": "(ніхто не онлайн)",
    "WAITING_CALLERS_COUNT": "{count} в очікуванні",
    "CALLER": "Абонент",
    "NUMBER": "Номер",
    "WAIT_TIME": "Час очікування",
    "QUEUES": "Черги",
    "ACTION": "Дія",
    "PICKUP_CALL": "Прийняти",
    "PICKING_UP": "Прийняття...",
    "PICKUP_SUCCESS": "Запит на прийняття виклику успішно надіслано.",
    "PICKUP_ERROR": "Не вдалося прийняти виклик. Будь ласка, спробуйте ще раз.",
    "PICKUP_DISABLED_TOOLTIP": "Ви не можете прийняти виклик, коли ви на розмові або офлайн.",
    "CHAT_STATUS": {
      "NO_ACCESS": "Немає доступу"
    },
    "PHONE_STATUS": {
      "NO_ACCESS": "Немає доступу"
    }
  }
}
